import React from "react";

import CardFullCalendar from "components/cards/calendario/CardFullCalendar.js";


export default function Principal() {
  if (localStorage.getItem("fist") == 0 || localStorage.getItem("fist") === null || localStorage.getItem("fist") === undefined) {
    localStorage.setItem("fist", 1);
    window.location.reload();
  }
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          <CardFullCalendar />

        </div>
        
      </div>
    </>
  );
}
